import React, { Component } from "react";
import PropTypes from 'prop-types';

import "./TemplateItem.scss";

class TemplateItem extends Component { 
  static propTypes = {
    template: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
  };


  render() {
    const { template, type } = this.props;

    const srcPreview = (template && template.thumbnail && template.thumbnail.url) ? template.thumbnail.url : null;
    const bgStyle = {
      backgroundImage:` url(${srcPreview})`,
      backgroundSize: 'cover',
    };

    return (
      <div className="template-wrapper">
        <div className="template-image-wrap">
          <div className="template-image" style={bgStyle}>
            <div className={'woman-img ' + type} />
          </div>
        </div>
        <div className="template-info">
          <div className="info-title">Имя Фамилия Консультанта</div>
          <div className="info-text">Консультант по питанию,<br />Независимый Партнер Herbalife Nutrition</div>
          <div className="info-footer">
            <div className="info-logo" />
            <div className="info-contacts">+7 999 000–00–00<br />example @gmail.com</div>
          </div>
          <div className="info-join">Присоединяйтесь!</div>
        </div>
      </div>
    );
  }
}

export default TemplateItem;
